/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useContext, useCallback, useState } from 'react';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { WizardPage } from '@xengage/gw-portals-wizard-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { useTranslator } from '@jutro/locale';
import { CurrencyValue, Loader }  from '@jutro/components'
import { ViewModelForm,  ViewModelServiceContext, withViewModelService } from '@xengage/gw-portals-viewmodel-react';
import { MLConfirmationPolicyDetailsBox } from 'ml-capability-policychange-common-react';
import { LocalDateUtil } from '@xengage/gw-portals-util-js';
import { MLNotificationBlockUtil } from 'ml-portals-util-react';
import { ReinstatementService } from 'ml-capability-reinstatement';
import { MLModalService } from 'ml-portals-services-react';
import { platformMessages } from 'ml-components-platform-react';
import { MLQuoteNameUtil } from 'ml-portals-util-js';

import metadata from './MLReinstatementConfirmationPage.metadata.json5';
import messages from './MLReinstatementConfirmationPage.messages';
import styles from './MLReinstatementConfirmationPage.module.scss'

import { TooltipIcon  } from '@jutro/components';

import { IntlContext } from '@jutro/legacy/locale';

function MLReinstatementConfirmationPage(props) {
    const {
        updateWizardData, wizardData, history
    } = props;
    const { submissionVM } = wizardData;
    const { authHeader } = useAuthentication();
    const intl = useContext(IntlContext);
    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);
    const [ fullSubmissionVM, updateFullSubmissionVM ] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    const AlertService = MLNotificationBlockUtil();
    const ModalService = MLModalService();

    useEffect(() => {
        const promise = ReinstatementService.getJobData(submissionVM.jobNumber.value, authHeader);
        ModalService.showProgressDialog(platformMessages.loading, promise);
        promise.then((result) => {
            updateFullSubmissionVM(viewModelService.create(
                result,
                'pc', 
                'metlife.edge.capabilities.reinstatement.dto.ReinstatementDTOML'
            ));
            setIsLoading(false)
        })
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        AlertService.clearAlerts();
        AlertService.addSuccessAlert(translator(messages.policyReinstated), 'policyReinstatementScreen');
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoading])

    const printConfirmation = () => {
        window.print();
    };

    const goToAccount = () => {
        history.push(`/accounts/${submissionVM.value.account.accountNumber}/summary`);
    };
    const anyOpenrClosedContingencies = () => {
        return fullSubmissionVM?.value?.openOrClosedContingencies?.length > 0 ? true : false;
    };

    const formatDate = (gwDateVal) => {
        if(gwDateVal){
            const date = LocalDateUtil.toMidnightDate(gwDateVal);
            return intl.formatDate(date, { year: 'numeric', month: '2-digit', day: '2-digit' })
        }
    };
    const getPriceColumnHeader = useCallback(() => {
        const price = _.get(fullSubmissionVM, 'changeInCost.value.amount', 0);
        if(price <= 0){
            return <>translator(messages.refundDue)</>
        }
        return <>{translator(messages.amountDue)}</>
    }, [fullSubmissionVM, translator]);

    const getChangeInCostDisplay = useCallback(() => {
        const copyChange = _.get(fullSubmissionVM, 'changeInCost.value', {});
        if(copyChange.amount){
            copyChange.amount = Math.abs(copyChange.amount);
        }
        return <CurrencyValue value={copyChange} />
    }, [fullSubmissionVM]);


    const hasRequiredDocumentation = () => {
        return _.get(fullSubmissionVM, 'value.actionRequiredDocuments', []).length > 0;
    };

    const getRequiredDocumentList = () => {
        return (
            <>
                {_.get(fullSubmissionVM, 'value.actionRequiredDocuments', []).map((document, index) => 
                    <li key={index}>{document}</li>
                )}
            </>
        )
    }

    const isPersonalAuto = () => {
        return submissionVM.value.isPersonalAuto();
    };

    const viewPolicyDocuments = () => {
        history.push(`/policies/${submissionVM.value.policyNumber}/documents`);
    };

    const viewIDCards = () => {
        history.push(`/accounts/${submissionVM.value.account.accountNumber}/documents`);
    };

    const actionCell = (obj, index) => {
        if(index === 0){
            return <a onClick={viewPolicyDocuments}>{translator(messages.view)}</a>
        }
        return <a onClick={viewIDCards}>{translator(messages.view)}</a>
    }

    const documentCell = (obj, index) => {
        if(index === 0){
            return <>{translator(messages.yourPolicyDocuments)}</>
        }
        return <>{translator(messages.yourIDCards)}</>
    }

    const overrideProps = {
        requiredDocumentationListContainer: {
            visible: hasRequiredDocumentation()
        },
        requiredDocumentationList: {
            content: getRequiredDocumentList()
        },
        documentTableHeader: {
            content: translator(messages.typePolicy, {
                policyType: MLQuoteNameUtil.getProductName(_.get(submissionVM, 'value.productCode'))
            })
        },
        documentTable: {
            data: isPersonalAuto() ? [{},{}] : [{}] 
        },
        policyDetails: {
            changeTypeLabel: translator(messages.change),
            policyNumber: _.get(fullSubmissionVM, 'value.policyNumber'),
            paymentMethod: _.get(fullSubmissionVM, 'paymentDetails.ratingPaymentMethod_ML.value.code'),
            endingIn: _.get(fullSubmissionVM, 'value.paymentDetails.last4Digits_ML'),
            paymentSchedule:  _.get(fullSubmissionVM, 'value.paymentDetails.paymentPlan_ML.name'),
            insured: _.get(fullSubmissionVM, 'value.account.accountHolder', {}),
            secondaryInsured: _.get(fullSubmissionVM, 'value.secondaryInsured_ML.displayName'),
            effectiveDate: formatDate(_.get(fullSubmissionVM, 'effectiveDate.value')),
            amount: _.get(fullSubmissionVM, 'value.changeInCost')
        },
        anyOpenContingencies : {
            visible: anyOpenrClosedContingencies()
        },
        documentIterable: {
            content:anyOpenrClosedContingencies() ?(<div>
                {fullSubmissionVM?.value?.openOrClosedContingencies?.map((value) => {
                    return <div>
                        <li>{value.title} 
                        <TooltipIcon
                            text={value.description_ML}
                            />
                        </li>
                    </div>
                })}
            </div>): undefined
        }
    };

    const resolvers = {
        resolveClassNameMap: styles,
        resolveCallbackMap: {
            printConfirmation,
            goToAccount,
            getChangeInCostDisplay,
            getPriceColumnHeader,
            documentCell,
            actionCell
        },
        resolveComponentMap: {
            MLConfirmationPolicyDetailsBox
        }
    }

    if (isLoading) {
        return <Loader loaded={!isLoading} />;
    }

    return (
        <WizardPage
            showCancel={false}
            showNext={false}
            showPrevious={false}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={wizardData}
                overrideProps={overrideProps}
                onModelChange={updateWizardData}
                classNameMap={resolvers.resolveClassNameMap}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                
            />
        </WizardPage>
    );
}

export default withRouter(withViewModelService(MLReinstatementConfirmationPage));